<template>
    <div class="row" style="">
        <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3">
            <label>Destination <span>{{ destination.order + 1 }} </span></label>
            <slot name="actions">
                <el-tooltip content="This will remove the destination from the flow."
                            effect="dark"
                            :open-delay="300"
                            placement="top">
                    <base-button class="right" type="danger" icon @click="$emit('remove')">
                        <font-awesome-icon :icon="['fal','trash']"></font-awesome-icon>
                    </base-button>
                </el-tooltip>
            </slot>
        </div>
        <div class="col-sm-9 col-md-9 col-lg-9 col-xl-9">
            <base-radio inline name="ringgroup" class="ml-0 mr-0"
                        v-model="destination.type">
                Ringgroup
            </base-radio>
            <base-radio inline name="default" class="ml-0 mr-0"
                        v-model="destination.type">
                Default
            </base-radio>
            <base-radio inline name="ivr" class="ml-0 mr-0"
                        v-model="destination.type">
                IVR
            </base-radio>
            <base-radio inline name="queue" class="ml-0 mr-0"
                        v-model="destination.type">
                Queue
            </base-radio>
            <base-radio inline name="voicemail" class="ml-0 mr-0"
                        v-model="destination.type">
                Voicemail
            </base-radio>
            <hr>
        </div>
        <div v-if="destination.type === 'ringgroup'"
             class="col-sm-9 offset-sm-3 col-md-9 offset-md-3 col-lg-9 offset-lg-3 col-xl-9 offset-xl-3">
            <ringgroup-selector class="mb-4 mt-1"
                                :initial-selected-ringgroup="destination.ringgroup"
                                v-on:add="handleDestinationRinggroupAdd($event)"
                                v-on:remove="handleDestinationRinggroupRemove($event)"></ringgroup-selector>
            <div>

                <label>Timeout</label> <br>

                <el-input-number v-model="destination.timeout"
                                 :min="1"
                                 :value="30"
                                 :max="60"></el-input-number>

                <small id=""
                       class="form-text text-muted">
                    Each ring is +/- 4 seconds. {{
                        destination.timeout
                    }} seconds is {{ Math.floor(destination.timeout / 4) }} rings. <br> This timeout
                    determines the amount of seconds before
                    the call will flow into the next destination (if available).
                </small>
            </div>


        </div>
        <div v-if="destination.type === 'default'"
             class="col-sm-9 offset-sm-3 col-md-9 offset-md-3 col-lg-9 offset-lg-3 col-xl-9 offset-xl-3">
            <div class="row">
                <div class="col-12 col-xl-6">
                    <label>Devices:</label>
                    <s-i-p-device-selector
                        :initial-selected-devices="destination.devices"
                        v-on:add="handleDestinationDeviceAdd($event)"
                        v-on:remove="handleDestinationDeviceRemove($event)"></s-i-p-device-selector>
                </div>
                <div class="col-12 col-xl-6">
                    <label>Numbers:</label>
                    <phone-number-selector
                        :initial-phone-numbers="destination.numbers"
                        v-on:update="handleDestinationNumberUpdate($event)"
                        v-on:remove="handleDestinationNumberRemove($event)"
                        v-on:add="handleDestinationNumberAdd()"></phone-number-selector>
                </div>
                <div class="col-12 mt-2">
                    <label>Timeout</label><br>
                    <el-input-number v-model="destination.timeout"
                                     :min="1"
                                     :value="31"
                                     :max="60"></el-input-number>
                    <small id="timeoutHelp"
                           class="form-text text-muted">
                        Each ring is about 4 seconds. {{
                            destination.timeout
                        }} seconds is {{ Math.floor(destination.timeout / 4) }} rings. <br> This timeout
                        determines the amount of seconds before
                        the call will flow into the next destination (if available).
                    </small>
                </div>

                <div class="col-12 mt-4">
                    <el-checkbox v-model="destination.intercom">
                        <slot name="label">
                            <label>Intercom</label>

                        </slot>
                    </el-checkbox>
                    <small id="intercomHelp"
                           class="form-text text-muted">
                        We'll send along information with the call that should be interpreted by the receiving phone as
                        an intercom request. We cannot guarantee compatibility with every device.
                    </small>
                </div>
            </div>
        </div>
        <div v-if="destination.type === 'ivr'"
             class="col-sm-9 offset-sm-3 col-md-9 offset-md-3 col-lg-9 offset-lg-3 col-xl-9 offset-xl-3">
            <i-v-r-selector class="mb-4 mt-1"
                            :initial-i-v-r="destination.ivr"
                            v-on:update="handleDestinationIVRUpdate($event)"></i-v-r-selector>
        </div>
        <div v-if="destination.type === 'queue'"
             class="col-sm-9 offset-sm-3 col-md-9 offset-md-3 col-lg-9 offset-lg-3 col-xl-9 offset-xl-3">
            <queue-selector class="mb-4 mt-1"
                            :initial-queue="destination.queue"
                            v-on:update="handleDestinationQueueUpdate($event)"></queue-selector>
        </div>
        <div v-if="destination.type === 'voicemail'"
             class="col-sm-9 offset-sm-3 col-md-9 offset-md-3 col-lg-9 offset-lg-3 col-xl-9 offset-xl-3">
            <voicemail-selector class="mb-4 mt-1"
                                :initial-voicemail="destination.voicemail"
                                v-on:update="handleVoicemail($event)"></voicemail-selector>
        </div>
        <div class="col">
            <hr>
        </div>
    </div>
</template>

<script>
import QueueSelector from "../Queue/QueueSelector";
import IVRSelector from "../IVR/IVRSelector";
import PhoneNumberSelector from "../../pages/PhoneNumbers/PhoneNumberSelector";
import SIPDeviceSelector from "../../pages/SIPDevices/SIPDeviceSelector";
import RinggroupSelector from "../../pages/Ringgroup/RinggroupSelector";
import VoicemailSelector from "../../pages/Voicemail/VoicemailSelector";

export default {
    name: "DestinationSelector",
    components: {
        VoicemailSelector,
        RinggroupSelector,
        SIPDeviceSelector,
        PhoneNumberSelector,
        IVRSelector,
        QueueSelector,
    },
    props: {
        initialDestination: {
            type: Object,
            default: {
                type: 'default',
                ringgroup: null,
                devices: [],
                numbers: ['+32'],
                timeout: 30,
                intercom: false,
                ivr: null,
                queue: null,
                voicemail: null,
            },
        },
    },
    computed: {},
    data() {
        return {
            destination: this.initialDestination,
        }
    },
    methods: {
        handleDestinationDeviceAdd(event) {
            let device = event.device;
            this.destination.devices.push(device);
        },
        handleDestinationDeviceRemove(event) {
            let name = event.name;
            this.destination.devices = this.destination.devices.filter(d => d.name !== name);
        },
        handleDestinationRinggroupAdd(event) {
            this.destination.ringgroup = event.ringgroup;
        },
        handleDestinationRinggroupRemove() {
            this.destination.ringgroup = null;
        },
        handleDestinationIVRUpdate(event) {
            let IVR = event.name;
            this.destination.ivr = IVR;
        },
        handleDestinationQueueUpdate(event) {
            let queue = event.name;
            this.destination.queue = queue;
        },
        handleDestinationNumberAdd() {
            this.destination.numbers.push('+99');
        },
        handleDestinationNumberUpdate(event) {
            let number = event.number;
            let nIndex = event.nIndex;
            this.destination.numbers.splice(nIndex, 1, number);
        },
        handleDestinationNumberRemove(event) {
            let number = event.number;
            this.destination.numbers = this.destination.numbers.filter(d => d !== number);
        },
        handleVoicemail(voicemail) {
            this.destination.voicemail = voicemail.name;
        },
    },
    watch: {
        initialDestination: function (newDest, oldDest) {
            this.destination = newDest;
        },
        destination: {
            handler: function (newValue, oldValue) {
                this.$emit('update', newValue);
            },
            deep: true
        },

    }
}
</script>

<style scoped>

</style>
